<template>
  <v-dialog
    style="border-radius: 22px"
    width="388px"
    v-model="openPaymentDetails.flag"
  >
    <v-card style="border-radius: 22px" height="288">
      <v-card-text>
        <div class="text-center">
          <v-img
            class="payment-logo"
            height="136px"
            width="136px"
            :src="webinarPayment"
          >
          </v-img>
          <div class="payment-succesful my-3">Payment Successful</div>
          <div class="details my-5">
            Further details related to webinar will be sent via Whatsapp or
            Email
          </div>
          <div class="paid mt-5">You paid ₹{{ openPaymentDetails.price }}</div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// import * as animationData from "@/assets/animations/lotties.json";
// import Lottie from "vue-lottie";
// import Lottie from "./lottie.vue";

// import * as webinarPayment from "@/assets/animations/payment.json";

export default {
  name: "WebinarPaymentDetails",

  props: {
    openPaymentDetails: {
      type: Object,
      required: true,
    },
  },
  components: {
    // lottie: Lottie,
  },
  data() {
    return {
      webinarPayment: require("@/assets/animations/webinarAnimations.gif"),
      // defaultOptions: { animationData: animationData },
      // payment_gif: paymentGif,
      // success_default_options: { animationData: paymentGif },
      //   payment_gif:
      //     "https://d3da1k6uo8tbjf.cloudfront.net/38e292ce-2d51-11ef-a6f0-1e0199a71503?response-content-disposition=inline%3B%20filename%3D%22Animation%20-%201718701177637.json%22%3B%20filename%2A%3DUTF-8%27%27Animation%2520-%25201718701177637.json&response-content-type=application%2Fjson&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAS5PME4CTY5HJXGX6%2F20240618%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20240618T090155Z&X-Amz-Expires=86400&X-Amz-SignedHeaders=host&X-Amz-Signature=804e3ea64ecde2e80c1a07186538e3a2b2a1b48abde0c289d263f9f987408aca&Policy=eyJTdGF0ZW1lbnQiOlt7IlJlc291cmNlIjoiaHR0cHM6Ly9kM2RhMWs2dW84dGJqZi5jbG91ZGZyb250Lm5ldC8zOGUyOTJjZS0yZDUxLTExZWYtYTZmMC0xZTAxOTlhNzE1MDM~cmVzcG9uc2UtY29udGVudC1kaXNwb3NpdGlvbj1pbmxpbmUlM0IlMjBmaWxlbmFtZSUzRCUyMkFuaW1hdGlvbiUyMC0lMjAxNzE4NzAxMTc3NjM3Lmpzb24lMjIlM0IlMjBmaWxlbmFtZSUyQSUzRFVURi04JTI3JTI3QW5pbWF0aW9uJTI1MjAtJTI1MjAxNzE4NzAxMTc3NjM3Lmpzb25cdTAwMjZyZXNwb25zZS1jb250ZW50LXR5cGU9YXBwbGljYXRpb24lMkZqc29uXHUwMDI2WC1BbXotQWxnb3JpdGhtPUFXUzQtSE1BQy1TSEEyNTZcdTAwMjZYLUFtei1DcmVkZW50aWFsPUFLSUFTNVBNRTRDVFk1SEpYR1g2JTJGMjAyNDA2MTglMkZ1cy1lYXN0LTIlMkZzMyUyRmF3czRfcmVxdWVzdFx1MDAyNlgtQW16LURhdGU9MjAyNDA2MThUMDkwMTU1Wlx1MDAyNlgtQW16LUV4cGlyZXM9ODY0MDBcdTAwMjZYLUFtei1TaWduZWRIZWFkZXJzPWhvc3RcdTAwMjZYLUFtei1TaWduYXR1cmU9ODA0ZTNlYTY0ZWNkZTJlODBjMWEwNzE4NjUzOGUzYTJiMmExYjQ4YWJkZTBjMjg5ZDI2M2Y5Zjk4NzQwOGFjYSIsIkNvbmRpdGlvbiI6eyJEYXRlTGVzc1RoYW4iOnsiQVdTOkVwb2NoVGltZSI6MTcxODc4NzcxNX19fV19&Signature=Q-odlNUKnIfDm4mqVZaUc~MetbCO8JEXkO5FHul~lus9CQ1-8WYA6h0CkQX0IuttAEDXMQOKFSKOgdWxGcUPaEHJl3LusTDUOKpRUbbyaSHg1qD3t99k5X-ZjbkjMTLXFmyruy5jb0Fk1~S74VfreaNdwKV~ik9mk9-8yisn2-nCHyete6kuIFtrwFDj~NuzfUb6SYnQRKCM-Ar7gc~daGmqmr4-ZoPFMZCiJI2fkN93FD6GtyYlvAncLInkYfE4EkUUJjWwK3001zafZDli1egNcGuE29iAgXmF7CuDfgoRE8ic958u-psHQT2LmXOTMJtmoRvTLASS4m53o4GP9A__&Key-Pair-Id=K2BMZZDBFKKL41",
      //   options: {
      //     minimizable: false,
      //     playerSize: "standard",
      //     backgroundColor: "#fff",
      //     backgroundStyle: "color",
      //     theme: {
      //       controlsView: "standard",
      //       active: "light",
      //       light: {
      //         color: "#3D4852",
      //         backgroundColor: "#fff",
      //         opacity: "0.7",
      //       },
      //       dark: {
      //         color: "#fff",
      //         backgroundColor: "#202020",
      //         opacity: "0.7",
      //       },
      //     },
      //   },
    };
  },
  mounted() {
    // console.log("defaultOptions:", this.defaultOptions);
  },
};
</script>

<style lang="scss" scoped>
.payment-logo {
  margin-left: auto;
  margin-right: auto;
}
.payment-succesful {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 800;
  line-height: 20px;
  // text-align: left;
  color: #333333;
}
.details {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  color: #333333cc;
}
.paid {
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  line-height: 14px;
  // text-align: left;
  color: #27ae60;
}
</style>
